<script lang="ts">
  import { getCopy } from "../lib/stores/copy";
  import { sessionStore } from "../lib/stores/session";
  import { getSelectedLanguageName } from "../lib/helpers/language";
  import Typography from "./Typography.svelte";
  import { TypographyType } from "../lib/constants/typographyMap";
  import ChevronDown from "../assets/icons/chevron-down.svg";
  import SlideOverlay from "./SlideOverlay.svelte";
  import I18NOverlay from "./I18n/OverlayContent.svelte";

  let isLanguageSelectorOpen = false;

  const openLanguageSelector = () => isLanguageSelectorOpen = true;
  const onCloseClick = () => isLanguageSelectorOpen = false;

  $: copy = $getCopy("layout") as Record<string, string>;
  $: languages = $getCopy("languages", { basePath: "", defaultReturnValue: ["en"] }) as string[];
  $: currentLanguageName = getSelectedLanguageName($sessionStore.language, languages);
</script>

<nav class="fixed flex flex-col top-0 left-0 w-full h-full mt-12 bg-white lg:hidden items-center pt-10 gap-4 fooji-bg-image z-20">
  <Typography mobile={TypographyType.Headline1Special} desktop={TypographyType.Headline1Special}>
    <a class="block whitespace-nowrap" href="mailto:help@fooji.com">{copy.contactSupportCopy}</a>
  </Typography>
  {#if languages.length > 1}
    <hr class="my-4"/>
    <button class="flex items-center gap-1" on:click={openLanguageSelector}>
      <Typography mobile={TypographyType.Headline5Medium} desktop={TypographyType.Headline5Medium} copy={currentLanguageName} />
      <img src={ChevronDown} class="w-4 h-4" alt="" />
    </button>
  {/if}
</nav>
{#if isLanguageSelectorOpen}
  <SlideOverlay onOverlayClick={onCloseClick} {onCloseClick}>
    <I18NOverlay onSelect={onCloseClick} />
  </SlideOverlay>
{/if}

<style>
  hr {
    width: calc(100% - 2rem);
  }

  nav {
    background-color: var(--color-white);
  }
</style>
